import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Status } from '../../../helpers/enum';
import {
  LocalCampaignOrderDataStatisticsModel,
  RenaultLocalCampaignOrderListDTO,
} from '../../../models/renault-local-campaign-order-dto';
import { LocalCampaignMedia } from '../../../helpers/enum';
import { Helpers } from '../../../helpers/helpers';
import { Router } from '@angular/router';
import { LocalCampaignTelemarketingOrderDataStatisticsModel } from '../../../models/renault-local-campaign-telemarketing-order-dto';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/services/user.service';
import { RenaultUserDTO } from 'src/app/models/renault-user-dto';
import * as moment from 'moment';
import { DeclinedReasonComponent } from '../declined-reason-modal/declined-reason-modal.component';
import {
  PuntoapuntoLocalCampaignOrderDataStatisticsModel,
  RenaultPuntoapuntoLocalCampaignOrderListDTO,
} from 'src/app/models/renault-puntoapunto-local-campaign-order';
import { PuntoapuntoLocalCampaignOrderService } from 'src/app/services/puntoapunto-local-campaign-order.service';
import { PuntoapuntoLocalCampaignHtmlModalComponent } from '../puntoapunto-local-campaign-html-modal/puntoapunto-local-campaign-html-modal.component';
import { PuntoapuntoDeclinedReasonComponent } from '../puntoapunto-declined-reason-modal/puntoapunto-declined-reason-modal.component';

@Component({
  selector: 'puntoapunto-local-campaign-order-list-card',
  templateUrl: './puntoapunto-local-campaign-order-list-card.component.html',
  styleUrls: ['./puntoapunto-local-campaign-order-list-card.component.scss'],
})
export class PuntoapuntoLocalCampaignOrderListCardComponent implements OnInit {
  @Input() model: RenaultPuntoapuntoLocalCampaignOrderListDTO;
  @Output('refreshList') refreshList: EventEmitter<any> = new EventEmitter();
  modelStatistics: PuntoapuntoLocalCampaignOrderDataStatisticsModel;
  enviados: number = 0;
  error: number = 0;
  reactividad: number = 0;
  LocalCampaignMedia = LocalCampaignMedia;
  status: string = '';
  modalCampaignDistributors = [];
  user: RenaultUserDTO;
  loaded = false;
  actualDate = new Date(moment(new Date()).format('YYYY-MM-DDTHH:mm:ss'));
  desiredDate;
  crmOnlyCalls = false;

  constructor(
    private service: PuntoapuntoLocalCampaignOrderService,
    private router: Router,
    private modalService: NgbModal,
    private userService: UserService,
    private toastr: ToastrService,
    private helper: Helpers
  ) {}

  ngOnInit(): void {
    this.desiredDate = new Date(
      moment(this.model.DesiredDate).format('YYYY-MM-DDTHH:mm:ss')
    );

    this.getUserInfo();
    if (this.model.IdCampaignMedia == LocalCampaignMedia.Email) {
      this.service
        .getLocalCampaignOrderStatistics(this.model.IdOrderInt)
        .subscribe((resp) => {
          this.modelStatistics = resp;
          this.loaded = true;
          this.enviados =
            this.modelStatistics.Status.find(
              (x) => x.IdStatus == Status.Enviado
            )?.Contador ?? 0;
          this.error =
            this.modelStatistics.Status.find((x) => x.IdStatus == Status.Error)
              ?.Contador ?? 0;
          if (this.modelStatistics.Abiertos > 0) {
            this.reactividad =
              (this.modelStatistics.ClicksTotales * 100) /
              this.modelStatistics.Abiertos;
          }
          this.checkStatus();
        });
    }
  }

  getUserInfo() {
    this.userService.getUserData().subscribe((res) => {
      if (res == null) return;
      this.user = res;
      if (
        res.RolesListString.some((x) => x == 'RedCallcenter') &&
        !res.RolesListString.some(
          (x) =>
            x == 'ResponsablePv' || x == 'RedRespMktg' || x == 'RedJefeTaller'
        )
      )
        this.crmOnlyCalls = true;
    });
  }

  ngAfterViewChecked(): void {
    this.helper.enableBsTooltips();
  }

  checkStatus() {
    if (
      this.model.IdStatus != 3 &&
      this.model.IdStatus != 6 &&
      this.model.IdStatus != 11 &&
      this.model.IdStatus != 8 &&
      this.model.IdStatus != 19 &&
      this.model.IdStatus != 20 &&
      this.model.IdStatus != 21 &&
      this.enviados == 0
    ) {
      this.status = 'SIN CONTACTOS';
      this.model.Status = 'SIN CONTACTOS';
    } else {
      this.status = this.model.Status;
    }

    if (this.model.IdStatus == 3 && this.model.HasOrderValidation) {
      this.status += ' DE APROBACIÓN';
    }
  }

  showCampaignHtml() {
    const modalRef = this.modalService.open(
      PuntoapuntoLocalCampaignHtmlModalComponent,
      { centered: true, size: 'lg' }
    );
    modalRef.componentInstance.idOrder = this.model.IdOrder;
  }

  showCampaignDistributors(content, campaignDistributors) {
    const modalRef = this.modalService.open(content, {
      centered: true,
      modalDialogClass: 'modal-distributor-list',
    });
    this.modalCampaignDistributors = campaignDistributors;
  }

  goToDetail(campaignMedia) {
    var media = '';
    switch (campaignMedia) {
      case LocalCampaignMedia.Email:
        media = 'email';
        break;
      case LocalCampaignMedia.Sms:
        media = 'sms';
        break;
      default:
        break;
    }
    this.router.navigate([
      '/campaigns/puntoapunto-local-campaign/' +
        media +
        '/statistics/' +
        this.model.IdOrder,
    ]);
  }

  continueCampaign() {
    this.router.navigate([
      '/campaigns/puntoapunto-local-campaign/order-segmentation/' +
        this.model.IdCampaign +
        '/' +
        this.model.IdOrder +
        '/' +
        this.model.IdSegmentation,
    ]);
  }

  deleteCampaign() {
    Swal.fire({
      title: '¿Quieres eliminar esta campaña?',
      text: 'La campaña se eliminará del listado',
      icon: 'warning',
      buttonsStyling: false,
      customClass: {
        cancelButton: 'btn btn-primary me-2',
        confirmButton: 'btn btn-outline-secondary',
      },
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText:
        '<i class="fa fa-trash-o" aria-hidden="true"></i> Eliminar',
      cancelButtonText:
        '<i class="fa fa-times" aria-hidden="true"></i> Cancelar',
      cancelButtonColor: '#d33',
      reverseButtons: true,
      focusCancel: true,
    }).then((result) => {
      if (result.value) {
        this.service.get(this.model.IdOrder).subscribe((res) => {
          Swal.close();
          if (
            res.IdStatus != Status.Pendiente &&
            res.IdStatus != Status.Borrador
          ) {
            Swal.fire({
              title:
                'Esta campaña ya no puede ser eliminada porque ya ha empezado el proceso de envío',
              icon: 'info',
              buttonsStyling: false,
              customClass: {
                confirmButton: 'btn btn-outline-secondary',
              },
              allowOutsideClick: false,
              confirmButtonText:
                '<i class="fa fa-check" aria-hidden="true"></i> Ok',
              focusCancel: true,
            });
          } else {
            this.service
              .changeStatus(this.model.IdOrder, Status.Baja)
              .subscribe(
                () => {
                  this.toastr.success(
                    'La campaña se ha eliminado correctamente'
                  );
                  this.refreshList.emit();
                },
                (err) => {
                  Swal.fire({
                    icon: 'error',
                    title: 'Error al eliminar el elemento',
                    text: 'Ocurrió un error',
                    buttonsStyling: false,
                    customClass: {
                      confirmButton: 'btn btn-outline-secondary'
                    },
                    confirmButtonText: 'Cerrar'
                  });
                }
              );
          }
        });
      }
    });
  }

  getDeclinedReason(idOrder) {
    const modalRef = this.modalService.open(
      PuntoapuntoDeclinedReasonComponent,
      { centered: true, size: 'md' }
    );

    modalRef.componentInstance.idOrder = idOrder;
  }

  DuplicateOrder() {
    if (this.model.CampaignAvailable) {
      Swal.fire({
        allowOutsideClick: false,
        icon: 'info',
        text: 'Espere por favor...',
      });

      Swal.showLoading();

      this.service.DuplicateOrder(this.model.IdOrder).subscribe((res) => {
        Swal.close();

        this.router.navigate([
          'campaigns/puntoapunto-local-campaign/order-segmentation/' +
            res.IdCampaign +
            '/' +
            res.IdOrder +
            '/' +
            res.IdSegmentation,
        ]);
      });
    } else {
      Swal.fire({
        icon: 'info',
        title: 'Esta campaña no se encuentra activa en estos momentos',
        text: 'No es posible crear el pedido',
        buttonsStyling: false,
        customClass: {
          confirmButton: 'btn btn-outline-secondary'
        },
        confirmButtonText: 'Cerrar'
      });
    }
  }

  changeStatus() {
    Swal.fire({
      html:
        '<p>Esta campaña ya está configurada y tiene fecha de envío</p>' +
        '<p>Puedes editarla pero, ten en cuenta que <strong>volverá al estado de borrador y tendrás que volver a validar el envío</strong></p>',
      icon: 'warning',
      buttonsStyling: false,
      customClass: {
        cancelButton: 'btn btn-primary me-2',
        confirmButton: 'btn btn-outline-secondary',
      },
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: '<i class="fa fa-check" aria-hidden="true"></i> Sí',
      cancelButtonText: '<i class="fa fa-times" aria-hidden="true"></i> No',
      cancelButtonColor: '#d33',
      reverseButtons: true,
      focusCancel: true,
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          allowOutsideClick: false,
          icon: 'info',
          text: 'Espere por favor...',
        });
        Swal.showLoading();

        this.service.get(this.model.IdOrder).subscribe((res) => {
          Swal.close();

          if (res.IdStatus != Status.Pendiente) {
            Swal.fire({
              title:
                'Esta campaña ya no puede ser modificada porque ya ha empezado el proceso de envío',
              icon: 'info',
              buttonsStyling: false,
              customClass: {
                confirmButton: 'btn btn-outline-secondary',
              },
              allowOutsideClick: false,
              confirmButtonText:
                '<i class="fa fa-check" aria-hidden="true"></i> Ok',
              focusCancel: true,
            });
          } else {
            this.service
              .changeStatus(this.model.IdOrder, Status.Borrador)
              .subscribe(
                () => {
                  this.continueCampaign();
                },
                (err) => {
                  Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Ocurrió un error',
                    buttonsStyling: false,
                    customClass: {
                      confirmButton: 'btn btn-outline-secondary'
                    },
                    confirmButtonText: 'Cerrar'
                  });
                }
              );
          }
        });
      }
    });
  }
}
